import React, { Component } from 'react'

import {parseTimestamp} from '../../../utils'

class EventsTable extends Component {

    constructor(props){
        super(props)
        this.state = {
            orderedEvents: [],
            actualPage: 0,
            totalPages: 0
        }
        this.eventsOrdering = this.eventsOrdering.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    eventsOrdering(events){
        var result = []
        // Parse events as an array
        for (var eventId in events){
            var newEvent = {...events[eventId], id: eventId}
            result.push(newEvent)
        }
        // Order array
        result.sort(function (a, b) {
            if (a.start > b.start) {return 1;}
            if (a.start < b.start) {return -1;}
            return 0;
        })
        return result
    }

    handlePageChange(event){
        this.setState({
            actualPage: event.target.value -1
        })

    }

    componentDidUpdate(prevProps){
        if (this.props.events !== prevProps.events){
            const {eventsOrdering} = this
            const newEvents = eventsOrdering(this.props.events)
            this.setState({
                orderedEvents: newEvents,
                actualPage: 0,
                totalPages: Math.ceil(newEvents.length / 10)
            })
        }
    }

    componentDidMount(){
        const {eventsOrdering} = this
        const newEvents = eventsOrdering(this.props.events)
        this.setState({
            orderedEvents: newEvents,
            actualPage: 0,
            totalPages: Math.ceil(newEvents.length / 10)
        })
    }

    render(){
        const {orderedEvents, actualPage, totalPages} = this.state
        const {handlePageChange} = this
        const {onEventIdClick} = this.props
        const eventsToShow = orderedEvents.slice(actualPage*10, actualPage*10 + 10)

        const getItemClass = (index, small) => {
            var classNameToUse = small ? 'table-events-td-small' : 'table-events-td-large'
            if (index % 2){
                return `${classNameToUse} table-item-light`
            }
            return `${classNameToUse} table-item-dark`
        }

        const getPageNumberElement = () => {
            var pagesComponent = []
            for (var i = 0; i < totalPages; i++){
                pagesComponent.push(
                    <div className='label-link-container'>
                        <input
                            type="button"
                            className={i === actualPage ? "label-link-selected": "label-link"}
                            value={i + 1}
                            onClick={handlePageChange}
                        />
                    </div>
                )
            }
            return pagesComponent
        }
        return(
            <div className="table-events-container">
                <table className="table-events">
                    <tr>
                        <th className="table-events-th-small"> ID </th>
                        <th className="table-events-th-small"> ID del cliente </th>
                        <th className="table-events-th-large"> Nombre fallecido </th>
                        <th className="table-events-th-small"> Fecha </th>
                        <th className="table-events-th-small"> Inicio </th>
                        <th className="table-events-th-small"> Final </th>
                        <th className="table-events-th-small"> Sala </th>
                        <th className="table-events-th-small"> espacios reservados </th>
                    </tr>
                    {
                        eventsToShow.map((item, index) => {
                            return (
                                <tr className="display-reservations-table-tr">
                                    <td
                                        className={`${getItemClass(index, true)} label-link`}
                                        onClick={event => onEventIdClick(item.id)}> {item.id} </td>
                                    <td className={getItemClass(index, true)}> {item.client_id} </td>
                                    <td className={getItemClass(index, false)}> {item.name} </td>
                                    <td className={getItemClass(index, true)}> {parseTimestamp(item.start).date} </td>
                                    <td className={getItemClass(index, true)}> {parseTimestamp(item.start).time} </td>
                                    <td className={getItemClass(index, true)}> {parseTimestamp(item.end).time} </td>
                                    <td className={getItemClass(index, true)}> {item.room.name} </td>
                                    <td className={getItemClass(index, true)}> {item.reservedSpaces} </td>
                                </tr>
                            )
                        })
                    }
                </table>
                <div>
                    {
                        totalPages > 1 ?
                        getPageNumberElement(1) :<div></div>
                    }
                </div>
            </div>
        )
    }
}

export default EventsTable
